import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../../Common/Components/DataTable";
import {
  checkEmpty,
  DeleteDataCategory,
  GetCategoryQuestion,
  EditDataCategory,
} from "../Components/Services";
import CommonFrom from "../../../../Common/Components/Form";
import CustomModal from "../../../../Common/Components/Modal/CustomModal";
import { input } from "./Create";
function List() {
  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);
  const handler = (pageNumber = 1) => {
    setstate({ ...state, loading: true });
    GetCategoryQuestion(pageNumber).then(data => {
      setstate({ ...state, loading: false, data: data });
    });
  };

  const deleteData = data => {
    setstate({ ...state, loading: true });
    DeleteDataCategory(data).then(() => {
      GetCategoryQuestion().then(result => {
        setstate({ loading: false, data: result });
      });
    });
  };

  useEffect(() => {
    handler();
  }, []);

  return (
    <Fragment>
      <Fragment>
        <DataTable
          loading={state.loading}
          heads={[{ title: "عنوان", key: "title" }]}
          header="دسته بندی سوالات متداول"
          textEmpty="دسته بندی وجود ندارد"
          list={state.data}
          data={state.data}
          textbtn="ایجاد دسته بندی سوال جدید"
          function={handler}
          linkbtn="/Admin/CategoryQuestionsSetting/Create"
          // currentPage={state.data.current_page}
          links={[
            {
              function: selected => {
                deleteData({ category_id: selected[0] });
              },
              color: "danger",
              size: "col-md-2",
              html: "حذف",
              multi: true,
              type: "delete",
            },
          ]}
        />
      </Fragment>
    </Fragment>
  );
}

export default List;
